module.exports = __webpack_public_path__ + "img/hydt_1.c673dad6.png";